/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgTriangleDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.44426 10.1691L4.23186 6.94655C3.73657 6.44969 4.08734 5.6001 4.78777 5.6001H11.2122C11.9126 5.6001 12.2634 6.44964 11.7682 6.94652L8.55611 10.1691C8.24909 10.4771 7.7513 10.4771 7.44426 10.1691Z'
      fill='currentColor'
    />
  </svg>
)
export default SvgTriangleDown
